import type { Block, BlockType } from '@hump/shared-types';

/** 生成唯一 block ID */
export function generateBlockId(): string {
  return 'b_' + crypto.randomUUID();
}

/** block 构造参数 */
export interface CreateBlockParams {
  docId: string;
  order: number;
  type: BlockType;
  level?: number;
  original?: string;
  /** image block */
  imageData?: string;
  imageWidth?: number;
  imageHeight?: number;
  caption?: string;
  /** formula block */
  latex?: string;
  /** table block */
  tableData?: { headers: string[]; rows: string[][] };
}

/** 创建带默认值的 block */
export function createBlock(params: CreateBlockParams): Block {
  return {
    id: generateBlockId(),
    docId: params.docId,
    type: params.type,
    level: params.level,
    order: params.order,
    original: params.original ?? '',
    translation: '',
    transStatus: 'none',
    updatedAt: new Date().toISOString(),
    annotations: [],
    vocab: [],
    imageData: params.imageData,
    imageWidth: params.imageWidth,
    imageHeight: params.imageHeight,
    caption: params.caption,
    latex: params.latex,
    tableData: params.tableData,
  };
}
